import { render, staticRenderFns } from "./userInfoMobile.vue?vue&type=template&id=062ca482&scoped=true"
import script from "./userInfoMobile.vue?vue&type=script&lang=js"
export * from "./userInfoMobile.vue?vue&type=script&lang=js"
import style0 from "./userInfoMobile.vue?vue&type=style&index=0&id=062ca482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ca482",
  null
  
)

export default component.exports